import api from './client.js'

export const ticketsAPI = {
  createTicket: (data) => api.post('/tickets', data),
  getTickets: (params) => api.get('/tickets', { params }),
  getTicket: (id) => api.get(`/tickets/${id}`),
  addReply: (id, data) => api.post(`/tickets/${id}/replies`, data),
  updateStatus: (id, status) => api.patch(`/tickets/${id}/status`, { status }),
  markAsRead: (id) => api.post(`/tickets/${id}/mark-read`),
  assignTicket: (id, assigned_to) => api.patch(`/tickets/${id}/assign`, { assigned_to }),
  assignTicketToGroup: (id, group_id) => api.patch(`/tickets/${id}/assign-group`, { group_id }),
  getStats: () => api.get('/tickets/stats/overview'),
  deleteTicket: (id) => api.delete(`/tickets/${id}`),
}

export const helpdeskGroupsAPI = {
  getGroups: () => api.get('/helpdesk/groups'),
  getGroup: (id) => api.get(`/helpdesk/groups/${id}`),
  getUserGroups: (userId) => api.get(`/helpdesk/groups/user/${userId}`),
  createGroup: (data) => api.post('/helpdesk/groups', data),
  updateGroup: (id, data) => api.put(`/helpdesk/groups/${id}`, data),
  deleteGroup: (id) => api.delete(`/helpdesk/groups/${id}`),
  addMember: (groupId, userId) => api.post(`/helpdesk/groups/${groupId}/members`, { userId }),
  removeMember: (groupId, userId) => api.delete(`/helpdesk/groups/${groupId}/members/${userId}`),
}
